// DesktopHeader.js
import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaSearch, FaChevronDown } from 'react-icons/fa';

function DesktopHeader({ userData, userId, categories, handleLogout, navigate }) {
  const [searchQuery, setSearchQuery] = useState('');
  const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
  const [showWriteDropdown, setShowWriteDropdown] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  
  const categoryDropdownRef = useRef(null);
  const writeDropdownRef = useRef(null);
  const profileDropdownRef = useRef(null);
  const searchRef = useRef(null);

  // Close all dropdowns
  const closeAllDropdowns = () => {
    setShowCategoryDropdown(false);
    setShowWriteDropdown(false);
    setShowProfileDropdown(false);
  };

  const toggleCategoryDropdown = () => {    
    // Close other dropdowns first
    setShowWriteDropdown(false);
    setShowProfileDropdown(false);
    // Then toggle this dropdown
    setShowCategoryDropdown(!showCategoryDropdown);
  };

  const toggleWriteDropdown = () => {
    // Close other dropdowns first
    setShowCategoryDropdown(false);
    setShowProfileDropdown(false);
    // Then toggle this dropdown
    setShowWriteDropdown(!showWriteDropdown);
  };

  const toggleProfileDropdown = () => {
    // Close other dropdowns first
    setShowCategoryDropdown(false);
    setShowWriteDropdown(false);
    // Then toggle this dropdown
    setShowProfileDropdown(!showProfileDropdown);
  };

  const navigateToCategory = (categoryId) => {
    navigate(`/category/${categoryId}`);
    closeAllDropdowns();
  };

  const navigateAndCloseDropdowns = (path) => {
    navigate(path);
    closeAllDropdowns();
  };

  const handleSearch = (e) => {
    e.preventDefault();

    try {
      if (searchQuery.trim()) {
        // Burada arama sonuçları sayfasına yönlendiriyoruz
        navigate(`/search-results?query=${encodeURIComponent(searchQuery.trim())}`);
      } else {
        throw new Error("Arama yapılacak kelime girmelisiniz.");
      }
    } catch (error) {
      console.error('Arama hatası:', error.message);
    }
  };
  
  const handleClickOutside = (event) => {
    // Check if clicked outside any dropdown
    const isOutsideAllDropdowns = (
      (!categoryDropdownRef.current || !categoryDropdownRef.current.contains(event.target)) &&
      (!writeDropdownRef.current || !writeDropdownRef.current.contains(event.target)) &&
      (!profileDropdownRef.current || !profileDropdownRef.current.contains(event.target))
    );
    
    // Check if not clicking on toggle buttons
    const isNotDropdownButton = (
      !event.target.closest('.write-button') && 
      !event.target.closest('.profile-button')
    );
    
    if (isOutsideAllDropdowns && isNotDropdownButton) {
      closeAllDropdowns();
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <header className="header">
      <div className="header-left">
        <div className="logo">
          <Link to="/dashboard">
            <img src="/LİBROZİ BOŞ MOR.png" alt="KitapOku Logo" className="logo-image" />
          </Link>
        </div>
        <nav>
          <ul>
            <li>
              <button onClick={toggleCategoryDropdown}>
                Kategoriler <FaChevronDown />
              </button>
              {showCategoryDropdown && (
                <div className="category-dropdown" ref={categoryDropdownRef}>
                  {categories.map((category) => (
                    <button
                      key={category.id}
                      onClick={() => navigateToCategory(category.id)}
                      className="category-item"
                    >
                      {category.name}
                    </button>
                  ))}
                </div>
              )}
            </li>
            <li>
              <button onClick={() => navigateAndCloseDropdowns('/discover')}>Keşfet</button>
            </li>
          </ul>
        </nav>
      </div>
      
      <form className="custom-search-bar" onSubmit={handleSearch}>
        <FaSearch className="custom-search-icon" />
        <input
          type="search"
          placeholder="Aramak"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          ref={searchRef}
        />
      </form>
      
      <div className="auth-buttons">
        <div className="write-dropdown" ref={writeDropdownRef}>
          <button onClick={toggleWriteDropdown} className="write-button">
            Yazmak <FaChevronDown />
          </button>
          {showWriteDropdown && (
            <div className="dropdown-menu">
              <button onClick={() => navigateAndCloseDropdowns('/new-story')}>
                Yeni bir hikaye oluştur
              </button>
              <button onClick={() => navigateAndCloseDropdowns('/my-stories')}>
                Hikayelerim
              </button>
            </div>
          )}
        </div>
        <div className="profile-dropdown" ref={profileDropdownRef}>
          <button onClick={toggleProfileDropdown} className="profile-button">
            <img src={userData.profilePhoto} alt="Profile" className="profile-image" />
            <span className="username">{userData.username}</span>
            <FaChevronDown />
          </button>
          {showProfileDropdown && (
            <div className="dropdown-menu">
              <button onClick={() => navigateAndCloseDropdowns(`/profile/${userId}`)}>Profil</button>
              <button onClick={() => navigateAndCloseDropdowns('/inbox')}>Gelen Kutusu</button>
              <button onClick={() => navigateAndCloseDropdowns('/notifications')}>Bildirimler</button>
              <button onClick={() => navigateAndCloseDropdowns('/library')}>Kütüphane</button>
              <button onClick={() => navigateAndCloseDropdowns('/settings')}>Ayarlar</button>
              <button onClick={handleLogout}>Çıkış Yap</button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default DesktopHeader;
